import { httpCreate } from "./http";
import conf from "@/config";

const http = httpCreate(conf.apipath + "/jobRecruit");

export const jobRecruit = {
  pageList(params) {
    return http.get("/pageList", { params });
  },
  createJob(body) {
    return http.post("/save", body);
  },
  updateStatus(id, status) {
    return http.put(`/status/${id}`, { status });
  },
  deleteJob(id) {
    return http.delete(`/${id}`);
  },
  updateJob(body) {
    return http.put(`/update`, body);
  },
  getJobDetail(id) {
    return http.get(`/${id}`);
  },
  activityList(jobId, params) {
    return http.get(`activityList/${jobId}`, { params });
  }
};
